import React, { useContext } from 'react';
import classnames from 'classnames';
import CommentBody from '@wix/da-shared-react/pkg/Comment/_partials/CommentBody';
import CommentContextProvider from '@wix/da-shared-react/pkg/Comment/_partials/CommentContext';
import DeviationDumbView from '@wix/da-shared-react/pkg/DeviationViews/Dumbo';
import { PapiComment, PapiDeviation } from '@wix/da-types-papi';
import { isImageDeviation } from '@wix/da-shared-react/pkg/DeviationViews/_helpers';
import { MobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';
import CommentLink from '@wix/da-shared-react/pkg/Comment/CommentLink';
import Timestamp from '@wix/da-shared-react/pkg/Timestamp';

import s from './MyComment.scss';

export interface Props {
  title: React.ReactNode;
  comment: PapiComment;
  thumb?: PapiDeviation;
  className?: string;
}
export const MyComment: React.FC<Props> = ({
  title,
  comment,
  thumb,
  className,
}) => {
  const isMobile = useContext(MobileContext);
  return (
    <div
      className={classnames(s['root'], className)}
      data-commentid={comment.commentId}
      data-typeid={comment.typeId}
      data-itemid={comment.itemId}
    >
      <div className={s['comment']}>
        {renderCommentHeader(title)}
        {renderCommentBody(comment)}
        {renderTimestamp(comment)}
      </div>
      {renderThumb(thumb, isMobile)}
    </div>
  );
};

const renderCommentHeader = (title: React.ReactNode) => {
  return <div className={s['header']}>{title}</div>;
};

const renderCommentBody = (comment: PapiComment) => {
  return (
    <CommentContextProvider comment={comment}>
      <div className={s['body']}>
        <CommentBody />
      </div>
    </CommentContextProvider>
  );
};

const renderTimestamp = (comment: PapiComment) => {
  return (
    <CommentLink comment={comment} className={s['timestamp']}>
      <Timestamp timestamp={comment.posted} />
    </CommentLink>
  );
};

const renderThumb = (thumb: PapiDeviation | undefined, isMobile: boolean) => {
  if (!thumb || !isImageDeviation(thumb)) {
    return null;
  }
  return (
    <div className={s['deviation']}>
      <DeviationDumbView
        deviation={thumb}
        width={isMobile ? 87 : 174}
        height={isMobile ? 80 : 128}
        className={s['thumb']}
      />
    </div>
  );
};

export default MyComment;
